export const dateFormat = "YYYY-MM-DDTHH:mm:ss" as const;
